import { takeLatest, all, call, put, select } from "redux-saga/effects";
import { updateHorario, allHorarios as allHorariosAction, resetHorario, filterHorarios, addHorario } from "./actions";
import types from "./types";
import {api} from "../../../services/api";
import consts from "../../../consts";


export function* allHorarios() {
  const { form } = yield select((state) => state.horario);
  try {
    yield put(updateHorario({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/horarios`);
  
    yield put(updateHorario({ form: { ...form, filtering: false } }));
    if (res.error) {
      alert(res.message);

      return false;
    }


      
    yield put(updateHorario({ horarios: [res]  }));
  } catch (error) {
    yield put(updateHorario({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* filterHorario() {
  const { form, horario } = yield select((state) => state.horario);
  try {
    yield put(updateHorario({ form: { ...form, filtering: true } }));
    const { data: res } = yield call(api.get, `/filter`, {
      filters: { email: horario.email, status: "A" },
    });
    yield put(updateHorario({ form: { ...form, filtering: false } }));
    if (res.error) {
      
      alert(res.message);

      return false;
    }

    //if (res.horarioes.length > 0) {
      if( 1<0){
      yield put(
        updateHorario({
          horario: res.horarioes[0],
          form: { ...form, filtering: false, disabled: false },
        })
      );
    } else {
      yield put(updateHorario( {form:{ ...form, disabled: false }} ));
    }
  } catch (error) {
   
    yield put(updateHorario({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}

export function* addHorarios() {

  const { form, horario, components, behavior } = yield select((state) => state.horario);

  try {
    yield put(updateHorario({ form: { ...form, saving: true } }));
    let res = {}
  
    if(behavior === "create"){
   
      const response = yield call(api.post, `/horarios`,{ ...horario, clienteID: `${consts.clienteId}`});
      res = response.data
   

    }else{
      console.log(horario)
      const response = yield call(api.put, `/horarios/${horario.id}`, horario);
       res= response.data
    }
    yield put(updateHorario({ form: { ...form, saving: false} }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allHorariosAction())
    yield put(updateHorario({ components: { ...components, drawer: false } }))
    yield put(resetHorario())
  
  } catch (error) {
    yield put(updateHorario({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}


export function* removeHorario() {
  const { form, horario, components } = yield select((state) => state.horario);
  try {
    yield put(updateHorario({ form: { ...form, saving: true } }));
    console.log(horario.id+ "estou em delete")
    const { data: res } = yield call(api.delete, `/horarios/${horario.id}`);
    yield put(updateHorario({ form: { ...form, saving: false  } ,
    }));
    if (res.error) {
      alert(res.message);

      return false;
    }

    yield put(allHorariosAction())
    yield put(updateHorario({ components: { ...components, drawer: false , confirmDelete: false} }))
    yield put(resetHorario())
  
  } catch (error) {
    yield put(updateHorario({ form: { ...form, saving: false } }));
    alert(error.message);
  }
}

export function* allServicos() {
  const { form } = yield select((state) => state.horario);

  try {
    yield put(updateHorario({ form: { ...form, filtering: true } }));
    const {data:res} = yield call(api.get, `/servicos`)

    
    yield put(updateHorario({ form: { ...form, filtering: false } }));

    if (res.error) {
   
      alert(res.message);

      return false;
    }

    yield put(updateHorario({servicos: res}))



  } 
  catch (error) {
    yield put(updateHorario({ form: { ...form, filtering: false } }));
    alert(error.message);
  }
}



export default all([
  takeLatest(types.ALL_HORARIOS, allHorarios),
  takeLatest(types.FILTER_HORARIO, filterHorario),
  takeLatest(types.ADD_HORARIO, addHorarios),
  takeLatest(types.REMOVE_HORARIO, removeHorario),
  takeLatest(types.ALL_SERVICES, allServicos),
]);
